import React from "react";
import ReactFC from "react-fusioncharts";
import FusionCharts from "fusioncharts";
import Column2D from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import { licenseKey } from "./license";
import ExcelExport from "fusioncharts/fusioncharts.excelexport";
import { KeyValue } from "../../interfaces";

ExcelExport(FusionCharts);

ReactFC.fcRoot(FusionCharts, Column2D, FusionTheme);

(FusionCharts as any).options["license"]({
  key: licenseKey,
  creditLabel: false,
});

interface FibFinancialsChartProps {
  onRender: any;
  categories: {
    category: {
      label: string;
    }[];
  }[];
  dataset: {
    seriesName: string;
    data: {
      value: string;
    }[];
  }[];
  chart: KeyValue;
  chartType: "mscolumn2d" | "column2d" | "mscombi2d";
  height?: string;
}

class FibFinancialsChart extends React.Component<FibFinancialsChartProps> {
  render() {
    const { categories, dataset, onRender, chart, chartType, height } =
      this.props;
    const baseChartConfig = {
      exportEnabled: "1",
      exportMode: "client",
      exportFormats: "PDF",
      theme: "fusion",
      divLineColor: "#d8d8d8",
      formatNumberScale: "0",
      xAxisNameFontColor: "#000000",
      numberPrefix: "$",
      setAdaptiveYMin: "1",
      showYAxisLine: "1",
      legendItemFontColor: "#000000",
      yAxisLineColor: "#d8d8d8",
      yAxisLineThickness: "1",
      showXAxisLine: "1",
      xAxisLineColor: "#000000",
      xAxisName: "API  Variable Queried: ASSETS",
      xAxisLineThickness: "1",
      labelFontColor: "#000000",
      labelFontSize: 20,
      yAxisValueFontColor: "#000000",
      paletteColors: "#38B8FF,#A48923,#00908C,#C8326C",
      showToolTip: "1",
      plotToolText: "$seriesName: $dataValue",
      animation: "0",
      ...chart,
    };

    const chartConfigs = {
      type: chartType,
      renderAt: "chart-container",
      width: "100%",
      height: height || "100%",
      dataFormat: "json",
      dataSource: {
        chart: baseChartConfig,
        categories: categories,
        [chartType === "column2d" ? "data" : "dataset"]: dataset,
      },
    };

    return (
      // @ts-ignore
      <ReactFC {...chartConfigs} onRender={onRender} id="fib-fin-chart" />
    );
  }
}

export default FibFinancialsChart;
